import AnalyzePerformanceWrapper from "./AnalyzePerformanceWrapper";
import "./AnalyzePerformanceWrapper.scss";

export default AnalyzePerformanceWrapper